import { render, staticRenderFns } from "./GerenciarConfiguracaoEquipamento.vue?vue&type=template&id=078b8b45&scoped=true&"
import script from "./GerenciarConfiguracaoEquipamento.vue?vue&type=script&lang=js&"
export * from "./GerenciarConfiguracaoEquipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b8b45",
  null
  
)

export default component.exports